import { useId } from 'react';

import { useUi } from '../i18n/ui-context';

/**
 * Language and theme switches.
 *
 * Both are labelled buttons rather than a bare glyph: a 40px touch target is the
 * minimum for a shared terminal being tapped quickly, and the text label is what
 * makes the control usable without interpreting an icon.
 */
export function UiToggles() {
  const { locale, theme, toggleLocale, toggleTheme, t } = useUi();
  const groupLabelId = useId();

  return (
    <div className="toggles" aria-labelledby={groupLabelId}>
      <span id={groupLabelId} className="visually-hidden">
        {t('common.language')}
      </span>
      <button
        type="button"
        className="button button--ghost"
        onClick={toggleLocale}
        // Announce the language the button switches *to*, so the label is
        // unambiguous in either direction.
        lang={locale === 'ar' ? 'en' : 'ar'}
      >
        {t('common.language')}
      </button>
      <button
        type="button"
        className="button button--ghost"
        onClick={toggleTheme}
        aria-pressed={theme === 'dark'}
        aria-label={`${t('common.theme')}: ${theme === 'dark' ? t('common.theme.dark') : t('common.theme.light')}`}
      >
        <span aria-hidden="true">{theme === 'dark' ? '☾' : '☀'}</span>
      </button>
    </div>
  );
}
